import { render, staticRenderFns } from "./TopicsPage.vue?vue&type=template&id=595e2a94&scoped=true&"
import script from "./TopicsPage.vue?vue&type=script&lang=js&"
export * from "./TopicsPage.vue?vue&type=script&lang=js&"
import style0 from "./TopicsPage.vue?vue&type=style&index=0&id=595e2a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e2a94",
  null
  
)

export default component.exports